import Vue from "vue";
import Vuex, { Store } from "vuex";
import createPersistedState from "vuex-persistedstate";

import admin from "./modules/admin/admin";
import components from "./modules/components/components";
import saleProcess from "./modules/saleProcess/saleProcess";
import user from "./modules/user/user";
import storage from "./modules/storage/storage";
import shoppingCart from "./modules/shoppingCart/shoppingCart";
import exception from "./modules/exception/exception";
import productModificationProcess from "./modules/productModificationProcess/productModificationProcess";
import customer from "./modules/customer/customer";
import productTransitionProcess from "./modules/productTransitionProcess/productTransitionProcess";
import productMultipleTransitionProcess from "./modules/productMultipleTransitionProcess/productMultipleTransitionProcess";
import apartment from "./modules/apartment/apartment";
import handover from "./modules/handover/handover";
import newExtrasProcess from "./modules/newExtrasProcess/newExtrasProcess";
import productChangeOfAddressProcess from "./modules/productChangeOfAddress/productChangeOfAddress";
import productChangeOfAddress2ndPhase from "./modules/productChangeOfAddress2ndPhase/productChangeOfAddress2ndPhase";
import inventoryProduct from "./modules/inventory/product/product";
import productsDependencies from "./modules/admin/products-dependencies/productsDependencies";
import bundleTypeConfigurations from "./modules/admin/bundle-type-configurations/bundleTypeConfigurations";
import genericSaleProcess from "./modules/genericSaleProcess/genericSaleProcess";
import { GENERIC_SALE_PROCESS_MODULE_NAME } from "./modules/genericSaleProcess";
import { VOIP_NUMBER_POOL_MODULE_NAME } from "./modules/voipNumberPool";
import voipNumberPool from "./modules/voipNumberPool/module";

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== "production";

const persistedStateConfig = {
	storage: window.sessionStorage,
	paths: ["user", "saleProcess", "shoppingCart", "components.stepper", "components.generalDialog"]
};

const storeConfig = {
	modules: {
		[GENERIC_SALE_PROCESS_MODULE_NAME]: genericSaleProcess,
		[VOIP_NUMBER_POOL_MODULE_NAME]: voipNumberPool,
		admin,
		apartment,
		bundleTypeConfigurations,
		components,
		customer,
		exception,
		handover,
		inventoryProduct,
		newExtrasProcess,
		productChangeOfAddress2ndPhase,
		productChangeOfAddressProcess,
		productModificationProcess,
		productMultipleTransitionProcess,
		productsDependencies,
		productTransitionProcess,
		saleProcess,
		shoppingCart,
		storage,
		user
	},
	strict: debug,
	plugins: [createPersistedState(persistedStateConfig)]
};

const store: Store<any> = new Vuex.Store(storeConfig);

export default store;
